import React, { useMemo } from 'react';
import {
  string, number, bool,
} from 'prop-types';
import Radio from '@active/react-ui/Radio';
import Locale from '@active/react-utils/i18n/Locale';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import isNil from 'lodash/isNil';
import PaymentOptionContent from './components/PaymentOptionContent/PaymentOptionContent';
import Currency from '../../../../../../../Currency';
import paymentOptionTypesConfig from '../../paymentOptionTypesConfig';
import { amountSum } from '../../../../../../../../../shared/utils/commonUtils';

const PaymentOption = ({
  type,
  amount: amountDue,
  currencyCode,
  hasPayPastDue,
  balance: balanceAmount,
  ...rest
}) => {
  const {
    currentPaymentOptionType,
    paymentProcessingFee,
    isPaymentProcessingFeeModel,
    futurePaymentProcessingFeeAmount,
  } = useSelector(state => state.paymentOptions);
  const titleId = paymentOptionTypesConfig[type === 'PAY_PASTDUE_AND_NEXT_INSTALLMENT' && !hasPayPastDue
    ? 'PAY_NEXT_INSTALLMENT' : type];
  const isChecked = useMemo(() => currentPaymentOptionType === type, [ currentPaymentOptionType, type ]);
  const amount = useMemo(() => (!isNil(amountDue)
    ? amountSum(amountDue, paymentProcessingFee)
    : amountDue), [ amountDue, paymentProcessingFee ]);

  const balance = useMemo(() => (!isNil(balanceAmount)
    ? amountSum(balanceAmount, futurePaymentProcessingFeeAmount)
    : balanceAmount), [ balanceAmount, futurePaymentProcessingFeeAmount ]);

  const isShowAmount = useMemo(() => {
    return (!isPaymentProcessingFeeModel || isChecked) && !isNil(amount);
  }, [ isPaymentProcessingFeeModel, isChecked, amount ]);

  return (
    <div className='checkout-payment-option'>
      <Radio value={type} className={classNames('checkout-payment-option-radio', {
        'checkout-payment-option-radio-checked': isChecked,
        'payment-option-radio_paymentplan': type === 'PAY_DEPOSIT_WITH_PAYMENT_PLAN',
      })}>
        <div className="checkout-payment-option_title">
          <div className="payment-option__title">
            <Locale id={titleId} />
          </div>
          {
            type === 'PAY_DEPOSIT_WITH_PAYMENT_PLAN'
            && <div className="payment-option__sub-title">
              <Locale id="checkout.lib.components.paymentOption.payDepositWithPaymentPlan"/>
            </div>
          }
          {
            isShowAmount && <div className='payment-option__currency'>
              <Currency amount={amount < 0 ? 0 : amount} code={currencyCode}/>
            </div>
          }
        </div>
      </Radio>
      {
        isChecked
        && <PaymentOptionContent
          {...rest}
          amount={amount}
          balance={balance}
          paymentOptionType={type}
          currencyCode={currencyCode}/>
      }
    </div>
  );
};

PaymentOption.propTypes = {
  type: string.isRequired,
  amount: number,
  currencyCode: string,
  hasPayPastDue: bool,
};

PaymentOption.defaultProps = {
  amount: undefined,
  currencyCode: undefined,
};

export default PaymentOption;
